import React, { useState } from "react";
import ToastPopup from "./ToastPopup";
import { FunctionEditQuestionModalProps, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const FunctionChecklistDetailsPopup: React.FC<FunctionEditQuestionModalProps> = ({ question, onClose, onSave, onChange }) => {
  const [message, setMessage] = useState<ToastMessage | null>(null);
  if (!question) return null;
  const handleValidationAndSave = () => {
    const functionAreaName = question.functionAreaName?.trim();
    const questionText = question.questionText?.trim();
    const evidenceRequired = question.evidenceRequired?.trim();
    if (!functionAreaName || !questionText || !evidenceRequired) {
      setMessage(createToastMessage("Please fill all required fields", "warning", 3000));
      return;
    }
    onSave();
  };
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Edit Checklist Question</h3>
        <label>Function Area Name:
          <input type="text" name="functionAreaName" value={question.functionAreaName || ""} onChange={onChange} required />
        </label>
        <label>Question Text:
          <textarea name="questionText" value={question.questionText || ""} onChange={onChange} required />
        </label>
        <label>Evidence Required:
          <textarea name="evidenceRequired" value={question.evidenceRequired || ""} onChange={onChange} required />
        </label>
        <label>ISO Clause Reference:
          <input type="text" name="isoClauseReference" value={question.isoClauseReference || ""} onChange={onChange} />
        </label>
        <label> Annex A Control Reference:
          <input type="text" name="annexAControlReference" value={question.annexAControlReference || ""} onChange={onChange} />
        </label>
        <div className="buttons">
          <button className="cancelbutton" onClick={onClose}>Cancel</button>
          <button className="savebutton" onClick={handleValidationAndSave}>Save</button>
        </div>
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
    </div>
  );
};
export default FunctionChecklistDetailsPopup;